import { cardSchemesConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addCardScheme = (state = initialState, action) => {
  switch (action.type) {
    case cardSchemesConstants.ADD_CARDSCHEME_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case cardSchemesConstants.ADD_CARDSCHEME_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case cardSchemesConstants.ADD_CARDSCHEME_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case cardSchemesConstants.ADD_CARDSCHEME_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
